<template>
  <v-calendar
    :color="color"
    type="day"
    :start="date"
    first-interval="6"
    interval-count="16"
    :events="events"
  >
    <template v-slot:day-header="{ present }">
      <template class="text-center"> </template>
    </template>

    <template v-slot:interval="{ hour }">
      <div
        @click="$emit('calendarClick', hour)"
        class="text-center"
        v-if="hour > 6 && hour < 22"
      >
        {{ hour }} <small>h</small>
      </div>
    </template>
  </v-calendar>
</template>

<script>
export default {
  props: {
    date: String,
    subjectClasses: Array
  },
  computed: {
    color() {
      return this.subjectClasses.length > 0 ? "primary" : "warning";
    },
    events() {
      return this.subjectClasses.map(this.setEvent);
    }
  },
  methods: {
    setEvent({ name, start_at, end_at }) {
      return {
        start: `${this.date} ${start_at}`,
        end: `${this.date} ${end_at}`,
        name: name
      };
    }
  }
};
</script>

<style lang="css">
div.v-calendar-daily__intervals-body {
  display: none !important;
}
</style>
